import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { SIZES_WITH_RESPONSIVE_OPTION } from './types';

export default function Inline({
    children,
    space = 'md',
    alignY = 'center',
    alignX = 'left',
    noWrap = false,
    shouldRenderInnerContainer = true,
    className,
    ...rest
}) {
    const classes = {};

    if (Array.isArray(space)) {
        space.forEach((item, index) => {
            classes[`bp-${index}-${item}`] = true;
            classes[`bp-${index}`] = true;
        });
    }
    else {
        classes[`${space}`] = true;
    }

    return (
        <div
            data-component="Inline"
            className={cx(
                'sarsa-inline',
                {
                    ...classes,
                    'no-wrap': noWrap,
                    top: alignY === 'top',
                    'y-center': alignY === 'center',
                    bottom: alignY === 'bottom',
                    left: alignX === 'left',
                    right: alignX === 'right',
                    'x-center': alignX === 'center'
                },
                className
            )}
            {...rest} >
            {shouldRenderInnerContainer ? <div>{children}</div> : children}
        </div>
    );
}

Inline.propTypes = {
    /** Contents */
    children: PropTypes.node,

    /** OneOf(['none', 'gutter', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'])
     * or array of sizes (one per mobile, tablet and desktop breakpoints)
     */
    space: SIZES_WITH_RESPONSIVE_OPTION,

    /** If true, items will not wrap */
    noWrap: PropTypes.bool,

    /** If items are of different height, sets the overall vertical alignment */
    alignY: PropTypes.oneOf(['center', 'top', 'bottom']),

    /** Aligns all items to the left, right or center, relative to the parent container */
    alignX: PropTypes.oneOf(['center', 'left', 'right']),

    /** Inner container is required, but you can turn off and provide your own */
    shouldRenderInnerContainer: PropTypes.bool,

    /** Additional class added to the outer container */
    className: PropTypes.string
};
